/**
* SEO Popups JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Popups component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'seo-popups',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.seo-popups__slider' ).length ) {
        $( '.seo-popups__slider' ).each( function( index, element ) {
          const updateSliderWidth = () => {
            const viewportWidth = window.innerWidth;

            const isSmallScreen = viewportWidth <= 640;

            slider.options = {
              ...slider.options,
              autoWidth: !isSmallScreen, // Enable autoWidth for larger screens
              fixedWidth: isSmallScreen ? viewportWidth - 64 : undefined, // Dynamic width for small screens
            };

            slider.refresh();
          };

          // Initialize Splide slider
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            perPage: 1,
            gap: '32px',
            autoWidth: true,
            arrows: false,
            pagination: false,
          } );

          slider.mount();

          // Update slider on load and resize
          updateSliderWidth();
          window.addEventListener( 'resize', updateSliderWidth );

          // Navigation button functionality
          document.querySelector( '.seo-popups__prev' ).addEventListener( 'click', function() {
            slider.go( '<' );
          } );

          document.querySelector( '.seo-popups__next' ).addEventListener( 'click', function() {
            slider.go( '>' );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-popups', COMPONENT );
} )( app );
